import * as Yup from 'yup';
import React, { useEffect, useState } from 'react'
import { getImages } from '../const'
import { Field, Form, Formik, ErrorMessage } from 'formik';
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import Switch from './Switch';


const FilterModal = ({ close, setFilterCompleteData, editItemValues, setOpenSavedSearchesModal, setEditItemValues, sliderParams, makeModelData }) => {
    const handleClearAll = (setValues, resetForm) => {
        resetForm();
        setValues({
            id: editItemValues?.id || '',
            make: editItemValues?.make || [],
            year: [sliderParams.year.defaultBottom, sliderParams.year.defaultTop],
            miles: [sliderParams.miles.defaultBottom, sliderParams.miles.defaultTop],
            dom: [sliderParams.dom.defaultBottom, sliderParams.dom.defaultTop],
            price: [sliderParams.price.defaultBottom, sliderParams.price.defaultTop],
            zipCode: '',
            milesZipCode: [sliderParams.zip.defaultBottom,sliderParams.zip.defaultTop],
            oem_dealer: true
        })
    }
    // Miles Slider
    const [milesZipCodeRange, setMilesZipCodeRange] = useState([sliderParams.zip.defaultBottom,sliderParams.zip.defaultTop]);
    const handlesetMilesZipCodeRange = (newMilage, setFieldValue) => {
        setMilesZipCodeRange(newMilage);
        const updatedMilesValue = newMilage;
        setFieldValue("milesZipCode", updatedMilesValue);
    };

    //Slider values
    const [year, setYear] = useState([sliderParams.year.defaultBottom, sliderParams.year.defaultTop]);
    const [miles, setMiles] = useState([sliderParams.miles.defaultBottom, sliderParams.miles.defaultTop]);
    const [dom, setDom] = useState([sliderParams.dom.defaultBottom, sliderParams.dom.defaultTop]);
    const [price, setPrice] = useState([sliderParams.price.defaultBottom, sliderParams.price.defaultTop]);

    const handleSliderChange = (field, newValues, setFieldValue) => {
        setFieldValue(field, newValues);

        switch (field) {
            case 'year': setYear(newValues); break;
            case 'miles': setMiles(newValues); break;
            case 'dom': setDom(newValues); break;
            case 'price': setPrice(newValues); break;
        }
    };

    //{console.log("editItemValues", editItemValues)}
    const [resetFields, setResetFileds] = useState(false);
    const [initialFormValues, setInitialFormValues] = useState(() => ({
        id: editItemValues?.id || '',
        make: editItemValues?.make || [],
        year: editItemValues?.year || year || [sliderParams.year.min, sliderParams.year.max],
        miles: editItemValues?.miles || miles || '',
        dom: editItemValues?.dom || dom || '',
        price: editItemValues?.price || price || '',
        zipCode: editItemValues?.zipCode || '',
        milesZipCode: editItemValues?.milesZipCode || milesZipCodeRange || '',
        oem_dealer: editItemValues?.oem_dealer,
    }));

    useEffect(() => {
        setInitialFormValues({
            id: editItemValues?.id || '',
            make: editItemValues?.make || [],
            year: editItemValues?.year || year || [sliderParams.year.min, sliderParams.year.max],
            miles: editItemValues?.miles || miles || '',
            dom: editItemValues?.dom || dom || '',
            price: editItemValues?.price || price || '',
            zipCode: editItemValues?.zipCode || '',
            milesZipCode: editItemValues?.milesZipCode || milesZipCodeRange || '',
            oem_dealer: editItemValues?.oem_dealer,
        });
    }, [editItemValues, year, miles, dom, price, milesZipCodeRange, resetFields]);
    const handleSubmit = (values, { resetForm }) => {
        const dynamicId = `id-${Date.now()}`;
        const updatedValues = { ...values, id: dynamicId };
        const checkedItems = makeModelData.filter((item, index) => updatedValues.make.includes(index));
        resetForm();
        close();
        setFilterCompleteData(checkedItems);
        setEditItemValues(values)
    };
    // Accordion Select Make
    const [activeIndex, setActiveIndex] = useState(null);
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };
    const [accordionItems, setAccordionItems] = useState(makeModelData);
    const handleCheckboxChange = (companyIndex, modelIndex, checked) => {
        setAccordionItems((prevItems) => {
            const updatedItems = [...prevItems];
            updatedItems[companyIndex].models[modelIndex].checked = checked;
            return updatedItems;
        });
    };

    const [showAllModels, setShowAllModels] = useState(false);
    const handleKeyDown = (event) => {
        const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete"];
        if (
            !allowedKeys.includes(event.key) &&
            !(event.key >= "0" && event.key <= "9")
        ) {
            event.preventDefault();
        }
    };

    const handleSaveSearch = (values, setValues, resetForm) => {
        const dynamicId = values.id;
        const updatedValues = { ...values };
        const existingData = JSON.parse(localStorage.getItem("filterCompleteData")) || [];

        if (dynamicId) {
            const existingIndex = existingData.findIndex((item) => item.id === dynamicId);
            if (existingIndex !== -1) {
                existingData[existingIndex] = updatedValues;
            } else {
                existingData.push(updatedValues);
            }
        } else {
            const newId = `${Date.now()}`;
            updatedValues.id = newId;
            existingData.push(updatedValues);
        }
        localStorage.setItem("filterCompleteData", JSON.stringify(existingData));
        close();
        setValues(updatedValues);
        setOpenSavedSearchesModal(true);
        resetForm();
        setResetFileds(true)
        setEditItemValues(values)
    };

    const checkMakeAll = (item,values) => {

        const existingIndex = values.findIndex((make) => make.title === item.title);

        return existingIndex !== -1 && values[existingIndex] && values[existingIndex].models.includes('all_models');
    }
    const validationSchema = Yup.object().shape({
        year: Yup.array()
            .of(Yup.number().min(sliderParams.year.min, `Year cannot be less than ${sliderParams.year.min}`))
    });
    return (
        <>
            <div className="modal-content p-0">
                <Formik
                    initialValues={initialFormValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, resetForm, setValues, errors, touched }) => (
                        <>
                            <Form className="custom-form w-100" autoComplete="off" name="filter-form">
                                <div className="modal-header p-3 chat-modal-header">
                                    <h1 className="modal-title filter-modal-title text-center w-100">
                                        Filters
                                    </h1>
                                    <button className="sm-box-close mt-0" type="button" onClick={close}>
                                        <img src={getImages('white-close.svg')} />
                                    </button>
                                </div>
                                <div className="modal-body p-4">
                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <div className='sm-title fw-600 text-uppercase mb-4'>1. Select Make</div>
                                            <div className='filter-inside-scroll'>
                                                <div className="accordion make-accordion" id="accordionExample">
                                                    {accordionItems.map((item, index) => (
                                                        <div className="accordion-item s-make-box" key={index}>
                                                            <h2 className="accordion-header p-0">
                                                                <div className='position-relative'>
                                                                    <button
                                                                        className={`accordion-button ps-5 ${activeIndex === index ? "" : "collapsed"}`}
                                                                        type="button"
                                                                        onClick={() => toggleAccordion(index)}
                                                                        aria-expanded={activeIndex === index}
                                                                        aria-controls={`collapse${index}`}
                                                                    >
                                                                        {item.title}
                                                                    </button>
                                                                    <div className="custom-checkbox ac-checkbox">
                                                                        <input
                                                                            type="checkbox"
                                                                            className="styled-checkbox"
                                                                            id={item.title}
                                                                            checked={checkMakeAll(item,values.make)}
                                                                            onChange={(e) => {
                                                                                const checked = e.target.checked;
                                                                                let updatedMake = [...(values.make || [])];
                                                                                const existingIndex = updatedMake.findIndex((make) => make.title === item.title);

                                                                                if (checked) {
                                                                                    if (existingIndex !== -1) {
                                                                                        updatedMake[existingIndex].models = ['all_models'];
                                                                                    } else {
                                                                                        updatedMake.push({ title: item.title, models: ['all_models'] });
                                                                                    }
                                                                                } else {
                                                                                    if (existingIndex !== -1) {
                                                                                        updatedMake.splice(existingIndex, 1);
                                                                                    }
                                                                                }
                                                                                setFieldValue('make', updatedMake);
                                                                            }}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        />
                                                                        <label htmlFor={item.title}></label>
                                                                    </div>
                                                                </div>
                                                            </h2>
                                                            <div
                                                                id={`collapse${index}`}
                                                                className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""}`}
                                                                data-bs-parent="#accordionExample"
                                                            >
                                                                <div className="accordion-body pt-0 ps-5">
                                                                    <ul>
                                                                        {item.models.slice(0, showAllModels ? item.models.length : 6).map((model, modelIndex) => (
                                                                            <li key={modelIndex}>
                                                                                <div className="custom-checkbox mb-2">
                                                                                    <Field
                                                                                        type="checkbox"
                                                                                        name="models"
                                                                                        value={model.name}
                                                                                        className="styled-checkbox"
                                                                                        id={`model-${index}-${modelIndex}`}
                                                                                        checked={values.make.some((make) =>
                                                                                            make.title === item.title && make.models.includes(model.name)
                                                                                        )}
                                                                                        onChange={(e) => {
                                                                                            const checked = e.target.checked;
                                                                                            let updatedMake = Array.isArray(values.make) ? [...values.make] : [];

                                                                                            // Find the index of the current item's title in the make array
                                                                                            const existingIndex = updatedMake.findIndex((make) => make.title === item.title);

                                                                                            if (checked) {
                                                                                                if (existingIndex !== -1) {
                                                                                                    // Add the model to the existing title's models array if not already present
                                                                                                    if (!updatedMake[existingIndex].models.includes(model.name)) {
                                                                                                        updatedMake[existingIndex].models.push(model.name);
                                                                                                    }
                                                                                                } else {
                                                                                                    // Add a new title with the current model
                                                                                                    updatedMake.push({ title: item.title, models: [model.name] });
                                                                                                }
                                                                                            } else {
                                                                                                if (existingIndex !== -1) {
                                                                                                    // Remove the model from the existing title's models array
                                                                                                    updatedMake[existingIndex].models = updatedMake[existingIndex].models.filter(
                                                                                                        (m) => m !== model.name
                                                                                                    );

                                                                                                    // Remove the title if no models are left
                                                                                                    if (updatedMake[existingIndex].models.length === 0) {
                                                                                                        updatedMake.splice(existingIndex, 1);
                                                                                                    }
                                                                                                }
                                                                                            }

                                                                                            setFieldValue("make", updatedMake); // Update Formik's value for make
                                                                                        }}
                                                                                    />
                                                                                    <label htmlFor={`model-${index}-${modelIndex}`}>{model.name !== '' ? model.name : '\u00A0'}</label>
                                                                                </div>
                                                                            </li>
                                                                        ))}
                                                                        {item.models.length > 6 && !showAllModels && (
                                                                            <button
                                                                                type="button"
                                                                                className="more-models-btn"
                                                                                onClick={() => setShowAllModels(true)}
                                                                            >
                                                                                More Models
                                                                            </button>
                                                                        )}
                                                                        {item.models.length > 6 && showAllModels && (
                                                                            <button
                                                                                type="button"
                                                                                className="more-models-btn"
                                                                                onClick={() => setShowAllModels(false)}
                                                                            >
                                                                                Show Less
                                                                            </button>
                                                                        )}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-5'>
                                            <div className='sm-title fw-600 text-uppercase mb-4'>2. Options</div>
                                            <div className='filter-inside-scroll'>
                                                <div className='filter-option-box mb-3'>
                                                    <div className='d-flex align-items-center justify-content-between mb-4'>
                                                        <div className='sm-title fw-600 font-17'>Year</div>
                                                        <div className='sm-title fw-500 font-16 text-lred'>{values.year[0]} - {values.year[1] == sliderParams.year.max ? "max" : values.year[1]}</div>
                                                    </div>
                                                    <RangeSlider
                                                        min={sliderParams.year.min}
                                                        max={sliderParams.year.max}
                                                        value={values.year}
                                                        onInput={(newValues) => {
                                                            handleSliderChange('year', newValues, setFieldValue)
                                                        }}
                                                    />
                                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                                        {/* <div className='sm-title fw-500 font-16 range-vlu-box'>{values.year[0]}</div>
                                                        <div className='sm-title fw-500 font-16 range-vlu-box'>{values.year[1] == sliderParams.year.max ? "max" : values.year[1]}</div> */}
                                                        <div>
                                                            <Field
                                                                name="year[0]"
                                                                type="text"
                                                                className={`sm-title fw-500 font-16 range-vlu-box ${touched.year?.[0] && errors.year?.[0] ? 'is-invalid' : ''}`}
                                                                value={values.year[0]}
                                                                min={sliderParams.year.min}
                                                                max={values.year[1]}
                                                            />
                                                        </div>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                className={`sm-title fw-500 font-16 range-vlu-box ${touched.year && errors.year ? 'is-invalid' : ''}`}
                                                                value={values.year[1] === sliderParams.year.max ? "" : values.year[1]}
                                                                placeholder='max'
                                                                onChange={(e) => {
                                                                    let newValue = Number(e.target.value);
                                                                    if (newValue > sliderParams.year.max) newValue = sliderParams.year.max;
                                                                    setFieldValue('year', [values.year[0], newValue]);
                                                                }}
                                                                min={values.year[0]}
                                                                max={sliderParams.year.max}
                                                            />
                                                            {/* {errors.year1 && <div className="error-message">{errors.year1}</div>} */}
                                                        </div>
                                                    </div>
                                                    <ErrorMessage name="year[0]" component="div" className="text-danger font-12 mt-2" />
                                                    {/* {touched.year && errors.year && (
                                                        <div className="error-message">{errors.year}</div>
                                                    )} */}
                                                </div>
                                                <div className='filter-option-box mb-3'>
                                                    <div className='d-flex align-items-center justify-content-between mb-4'>
                                                        <div className='sm-title fw-600 font-17'>Miles</div>
                                                        <div className='sm-title fw-500 font-16 text-lred'>{values.miles[0]}k - {values.miles[1] == sliderParams.miles.max ? "max" : values.miles[1] + "k"}</div>
                                                    </div>
                                                    <RangeSlider
                                                        min={sliderParams.miles.min}
                                                        max={sliderParams.miles.max}
                                                        value={values.miles}
                                                        onInput={(newValues) => handleSliderChange('miles', newValues, setFieldValue)}
                                                    />
                                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                                        {/* <div className='sm-title fw-500 font-16 range-vlu-box'>{values.miles[0] * 1000}</div>
                                                        <div className='sm-title fw-500 font-16 range-vlu-box'>{values.miles[1] == sliderParams.miles.max ? "max" : values.miles[1] * 1000}</div>
                                                         */}
                                                         <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            value={values.miles[0] * 1000} // Convert to km
                                                            onChange={(e) => {
                                                                const newValue = [Number(e.target.value) / 1000, values.miles[1]]; // Convert back to 'k'
                                                                setFieldValue('miles', newValue);
                                                            }}
                                                            min={sliderParams.miles.min * 1000}
                                                            max={values.miles[1] * 1000}
                                                        />
                                                        
                                                        <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            value={values.miles[1] === sliderParams.miles.max ? "" : values.miles[1] * 1000}
                                                            placeholder='max'
                                                            onChange={(e) => {
                                                                let newValue = Number(e.target.value) / 1000;
                                                                if (newValue > sliderParams.miles.max) newValue = sliderParams.miles.max;
                                                                setFieldValue('miles', [values.miles[0], newValue]);
                                                            }}
                                                            min={values.miles[0] * 1000}
                                                            max={sliderParams.miles.max * 1000}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='filter-option-box mb-3'>
                                                    <div className='d-flex align-items-center justify-content-between mb-4'>
                                                        <div className='sm-title fw-600 font-17'>Days on Lot</div>
                                                        <div className='sm-title fw-500 font-16 text-lred'>{values.dom[0]} - {values.dom[1] == sliderParams.dom.max ? "max" : values.dom[1]}</div>
                                                    </div>
                                                    <RangeSlider
                                                        min={sliderParams.dom.min}
                                                        max={sliderParams.dom.max}
                                                        value={values.dom}
                                                        onInput={(newValues) => handleSliderChange('dom', newValues, setFieldValue)}
                                                    />
                                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                                        {/* <div className='sm-title fw-500 font-16 range-vlu-box'>{values.dom[0]}</div>
                                                        <div className='sm-title fw-500 font-16 range-vlu-box'>{values.dom[1] == sliderParams.dom.max ? "max" : values.dom[1]}</div> */}
                                                        <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            value={values.dom[0]}
                                                            onChange={(e) => {
                                                                const newValue = [Number(e.target.value), values.dom[1]];
                                                                setFieldValue('dom', newValue);
                                                            }}
                                                            min={sliderParams.dom.min}
                                                            max={values.dom[1]}
                                                        />
                                                        
                                                        <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            value={values.dom[1] === sliderParams.dom.max ? "" : values.dom[1]}
                                                            placeholder='max'
                                                            onChange={(e) => {
                                                                let newValue = Number(e.target.value);
                                                                if (newValue > sliderParams.dom.max) newValue = sliderParams.dom.max;
                                                                setFieldValue('dom', [values.dom[0], newValue]);
                                                            }}
                                                            min={values.dom[0]}
                                                            max={sliderParams.dom.max}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='filter-option-box mb-3'>
                                                    <div className='d-flex align-items-center justify-content-between mb-4'>
                                                        <div className='sm-title fw-600 font-17'>Price Range</div>
                                                        <div className='sm-title fw-500 font-16 text-lred'>${values.price[0]}k - {values.price[1] == sliderParams.price.max ? "max" : "$" + values.price[1] + "k"}</div>
                                                    </div>
                                                    <RangeSlider
                                                        min={sliderParams.price.min}
                                                        max={sliderParams.price.max}
                                                        value={values.price}
                                                        onInput={(newValues) => handleSliderChange('price', newValues, setFieldValue)}
                                                    />
                                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                                        {/* <div className='sm-title fw-500 font-16 range-vlu-box'>{values.price[0] * 1000}</div>
                                                        <div className='sm-title fw-500 font-16 range-vlu-box'>{values.price[1] == sliderParams.price.max ? "max" : values.price[1] * 1000}</div> */}
                                                        <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            value={values.price[0] * 1000}
                                                            onChange={(e) => {
                                                                const newValue = [Number(e.target.value) / 1000, values.price[1]];
                                                                setFieldValue('price', newValue);
                                                            }}
                                                            min={sliderParams.price.min * 1000}
                                                            max={values.price[1] * 1000}
                                                        />
                                                        
                                                        <input
                                                            type="text"
                                                            className='sm-title fw-500 font-16 range-vlu-box'
                                                            placeholder='max'
                                                            value={values.price[1] === sliderParams.price.max ? "" : values.price[1] * 1000}
                                                            onChange={(e) => {
                                                                let newValue = Number(e.target.value) / 1000;
                                                                if (newValue > sliderParams.price.max) newValue = sliderParams.price.max;
                                                                setFieldValue('price', [values.price[0], newValue]);
                                                            }}
                                                            min={values.price[0] * 1000}
                                                            max={sliderParams.price.max * 1000}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-md-3'>
                                            <div className='sm-title fw-600 text-uppercase mb-4'>3. Distance</div>
                                            <div className='filter-inside-scroll'>
                                                <div className='filter-option-box pb-5 mb-3'>
                                                    <div className='mb-3'>
                                                        <div className='sm-title fw-600 font-17'>Zip Code</div>
                                                        <Field
                                                            type="text"
                                                            name="zipCode"
                                                            className="range-vlu-form w-100"
                                                            onKeyDown={handleKeyDown}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className='xs-title fw-300 font-14 mb-3'>Miles from Zip Code</div>
                                                        <RangeSlider
                                                            min={sliderParams.zip.min}
                                                            max={sliderParams.zip.max}
                                                            className="single-thumb"
                                                            // defaultValue={[0, 50]}
                                                            thumbsDisabled={[true, false]}
                                                            rangeSlideDisabled={true}
                                                            value={values?.milesZipCode}
                                                            onInput={(newMilage) => handlesetMilesZipCodeRange(newMilage, setFieldValue)}
                                                        />
                                                        <div className='d-flex align-items-center justify-content-between mb-3'>
                                                            <div className='range-vlu-form w-100'>{values.milesZipCode[1] == sliderParams.zip.max ? "max" : values.milesZipCode[1]}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='filter-option-box pb-4'>
                                                    <div className='mb-2'>
                                                        <div className='sm-title fw-600 font-17 mb-2'>Dealer Mismatch</div>
                                                        <Switch name="oem_dealer" label="Dealer Mismatch" value={values?.oem_dealer}/>
                                                    </div>
                                                    <div className='dm-info-text'>
                                                        <p><strong>Pro Tip:</strong> when toggled “ON” this will only show vehicle makes listed outside their original OEM.</p>
                                                        <p>Ex: a 911 listed at a Chevy store.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer d-flex align-items-center justify-content-between">
                                    <div>
                                        <button type='button' className='clear-all-btn' onClick={() => handleClearAll(setValues, resetForm)}>Clear Selection</button>
                                    </div>
                                    <div>
                                        <button type='button' className='transparent-btn filter-save-btn me-3' onClick={() => handleSaveSearch(values, setValues, resetForm)}>
                                            <span className='sv-save-icon'></span> Save this Search
                                        </button>
                                        <button type='submit' className='red-btn fw-500 font-1-1em w-190 filter-search-btn'>Search</button>
                                    </div>
                                </div>
                            </Form>
                        </>
                    )}
                </Formik>
            </div>
        </>
    )
}

export default FilterModal